import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { IconButton, Tooltip } from '@mui/material';

function SettingsIcon({ onClickHandler, variant = 'inline' }) {
  if (variant === 'floating') {
    return (
      <SettingsOutlinedIcon
        onClick={onClickHandler}
        titleAccess="General Settings"
        sx={{
          cursor: 'pointer',
          color: 'white',
          fontSize: '22px',
          backgroundColor: 'primary.dark',
          position: 'fixed',
          top: '10px',
          right: '12px',
          zIndex: 1100,
          margin: 0,
          padding: '7px',
          borderRadius: '50%',
          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
        }}
      />
    );
  }

  return (
    <Tooltip title="General Settings" placement="left">
      <IconButton
        onClick={onClickHandler}
        aria-label="General Settings"
        sx={{
          width: 44,
          height: 44,
          background: 'linear-gradient(135deg, #186098 0%, #0090D8 100%)',
          color: '#fff',
          boxShadow: '0 6px 16px rgba(0, 144, 216, 0.35)',
          '&:hover': {
            background: 'linear-gradient(135deg, #1e40af 0%, #1878B8 100%)',
          },
        }}
      >
        <SettingsOutlinedIcon sx={{ fontSize: 22 }} />
      </IconButton>
    </Tooltip>
  );
}

export default SettingsIcon;
